/** Swaps keys and values of a constant map, i.e. `{AVM: "avm"}` becomes `{avm: "AVM"}`. */
export type InvertedRecord<T extends Record<PropertyKey, PropertyKey>> = {[K in keyof T as T[K]]: K};

/** Invert keys and values of a record */
export function invertRecord<T extends Record<PropertyKey, PropertyKey>>(record: T): InvertedRecord<T> {
    return Object.fromEntries(Object.entries(record).map(([k, v]) => [v, k])) as InvertedRecord<T>;
}
